import { API_BASE_URL } from './config';

let problem = null;
const listeners = new Set();
let installed = false;
let nativeFetch;
const unavailableStatuses = new Set([500, 502, 503, 504, 520, 521, 522, 523, 524]);

function reportProblem() {
  problem = navigator.onLine === false ? 'offline' : 'maintenance';
  listeners.forEach(listener => listener());
}

export const subscribeAvailability = listener => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
export const getAvailability = () => problem;

export function isApiRequest(input) {
  try {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href);
    const base = new URL(API_BASE_URL, window.location.href);
    const path = base.pathname.replace(/\/$/, '');
    return url.origin === base.origin && (url.pathname === path || url.pathname.startsWith(`${path}/`));
  } catch {
    return false;
  }
}

// Installed before React mounts, so initial page requests are covered too.
export function installAvailabilityMonitor() {
  if (installed) return;
  installed = true;
  nativeFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const monitored = isApiRequest(input);
    try {
      const response = await nativeFetch(input, init);
      if (monitored && unavailableStatuses.has(response.status)) reportProblem();
      return response;
    } catch (error) {
      const signal = init?.signal || input?.signal;
      if (monitored && !signal?.aborted && error?.name !== 'AbortError' && error instanceof TypeError) reportProblem();
      throw error;
    }
  };
}

export async function checkAvailability() {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 8000);
  try {
    // A safe GET: never replay the request that failed (it may be a payment or edit).
    const response = await nativeFetch(`${API_BASE_URL.replace(/\/$/, '')}/`, {
      signal: controller.signal, cache: 'no-store',
    });
    const body = response.ok ? await response.json() : null;
    if (!response.ok || body?.message !== 'Hello World') throw new Error('Unavailable');
    return true;
  } catch {
    reportProblem();
    return false;
  } finally {
    clearTimeout(timeout);
  }
}
